import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemUserInterfacePreferencesRoute: InvariantJiraRoute = {
	name: 'global-settings-system-ui-default-user-preferences-apply',
	path: '/secure/admin/SetGlobalEmailPreference!default.jspa',
};
